// import { ntxAPI } from '@API/axiosNeatex';
// import { Card, CardBody, CardFooter } from '@components/card/card';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import type { APIResponse } from '@store/Shared/shared';
// import { TreeSelect } from 'antd';
// import React, { useState } from 'react';
// import { Table, Spinner, Form, Row, Col, Button, Alert, CardHeader } from 'react-bootstrap';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

// // Define types for our data

// interface AgingAnalysis {
//   supplierId: string;
//   supplierName: string;
//   supplierName2: string;
//   totalAmount: number;
//   age0To30: number;
//   age31To60: number;
//   age61To90: number;
//   ageOver90: number;
// }

// const AgingAnalysisReport: React.FC = () => {
//   const { treeSuppliersData } = useGetSuppliersList();
//   const [data, setData] = useState<AgingAnalysis[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   // Filter states
//   const [selectedSupplier, setSelectedSupplier] = useState<string>('');
//   const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
//   const [startDate, endDate] = dateRange;

//   // Function to fetch data with filters
//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       // Prepare query parameters

//       // API call with filters
//       const { data } = await ntxAPI.get<APIResponse<AgingAnalysis[]>>('Reports/GetAgingAnalysisReport', {
//         params: { SupplierId: selectedSupplier, AsOfDate: startDate }
//       });
//       if (data.succeeded === true) {
//         setData(data.data);
//       } else {
//         setError(data instanceof Error ? data.message : 'An unknown error occurred');
//       }

//       //   setData(response.data.data);
//     } catch (err) {
//       setError(err instanceof Error ? err.message : 'An unknown error occurred');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetFilters = () => {
//     setSelectedSupplier('all');
//     setDateRange([null, null]);
//   };

//   const formatCurrency = (amount: number): string => {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD'
//     }).format(amount);
//   };

//   // Calculate percentage of total for each age bucket
//   const calculatePercentage = (amount: number, total: number) => {
//     if (total === 0) return '0%';
//     return ` {Math.round((amount / total) * 100)}%`;
//   };

//   return (
//     <div className='container mt-4'>
//       <Card>
//         <CardHeader className='d-flex justify-content-between align-items-center'>
//           <h5 className='mb-0'>Aging Analysis Report</h5>
//           {data.length > 0 && (
//             <div>
//               <span className='me-2'>Showing: {data.length} suppliers</span>
//             </div>
//           )}
//         </CardHeader>

//         <CardBody>
//           {error && (
//             <Alert variant='danger' className='mb-4'>
//               Error loading data: {error}
//             </Alert>
//           )}

//           {/* Filters Section */}
//           <Card className='mb-4'>
//             <CardHeader>Filters</CardHeader>
//             <CardBody>
//               <Form>
//                 <Row className='g-3'>
//                   <Col md={4}>
//                     <Form.Group controlId='supplierFilter'>
//                       <Form.Label>Supplier</Form.Label>

//                       <TreeSelect
//                         showSearch
//                         className='w-100'
//                         treeLine
//                         // placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                         allowClear
//                         treeDefaultExpandAll={false} // لا تقم بتوسيع كل العقد افتراضيًا
//                         value={selectedSupplier}
//                         onChange={(option: any) => {
//                           setSelectedSupplier(option === null ? null : option);
//                         }}
//                         // loading={loading5}
//                         treeData={treeSuppliersData}
//                         treeNodeFilterProp='title'
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col md={4}>
//                     <Form.Group controlId='dateRangeFilter'>
//                       <Form.Label>Date Range</Form.Label>
//                       <DatePicker
                      
//                         selectsRange={true}
//                         startDate={startDate}
//                         endDate={endDate}
//                         onChange={update => setDateRange(update)}
//                         isClearable={true}
//                         className='form-control text-center'
//                         placeholderText='Select date range'
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col xs={12} className='text-end'>
//                     <Button variant='secondary' onClick={resetFilters} className='me-2'>
//                       Reset Filters
//                     </Button>
//                     <Button variant='primary' onClick={fetchData} disabled={loading}>
//                       {loading ? (
//                         <>
//                           <Spinner
//                             as='span'
//                             animation='border'
//                             size='sm'
//                             role='status'
//                             aria-hidden='true'
//                             className='me-2'
//                           />
//                           Loading...
//                         </>
//                       ) : (
//                         'Load Report'
//                       )}
//                     </Button>
//                   </Col>
//                 </Row>
//               </Form>
//             </CardBody>
//           </Card>

//           {/* Results Section */}
//           {loading ? (
//             <div className='text-center my-5'>
//               <Spinner animation='border' role='status'>
//                 <span className='visually-hidden'>Loading...</span>
//               </Spinner>
//               <p className='mt-2'>Loading aging analysis data...</p>
//             </div>
//           ) : data.length > 0 ? (
//             <div className='table-responsive'>
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>Supplier</th>
//                     <th>Total Amount</th>
//                     <th className='bg-age-0'>0-30 Days</th>
//                     <th className='bg-age-1'>31-60 Days</th>
//                     <th className='bg-age-2'>61-90 Days</th>
//                     <th className='bg-age-3'>Over 90 Days</th>
//                     <th>% Overdue</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map((item, index) => {
//                     const overdueAmount = item.age31To60 + item.age61To90 + item.ageOver90;
//                     return (
//                       <tr key={`${item.supplierId}-${index}`}>
//                         <td>
//                           <div>{item.supplierName}</div>
//                           <div className='text-muted small'>{item.supplierName2}</div>
//                         </td>
//                         <td>{formatCurrency(item.totalAmount)}</td>
//                         <td className='bg-age-0-light'>
//                           <div>{formatCurrency(item.age0To30)}</div>
//                           <div className='text-muted small'>{calculatePercentage(item.age0To30, item.totalAmount)}</div>
//                         </td>
//                         <td className='bg-age-1-light'>
//                           <div>{formatCurrency(item.age31To60)}</div>
//                           <div className='text-muted small'>
//                             {calculatePercentage(item.age31To60, item.totalAmount)}
//                           </div>
//                         </td>
//                         <td className='bg-age-2-light'>
//                           <div>{formatCurrency(item.age61To90)}</div>
//                           <div className='text-muted small'>
//                             {calculatePercentage(item.age61To90, item.totalAmount)}
//                           </div>
//                         </td>
//                         <td className='bg-age-3-light'>
//                           <div>{formatCurrency(item.ageOver90)}</div>
//                           <div className='text-muted small'>
//                             {calculatePercentage(item.ageOver90, item.totalAmount)}
//                           </div>
//                         </td>
//                         <td>
//                           <span
//                             className={`badge ${
//                               overdueAmount === 0 ? 'bg-success' : item.ageOver90 > 0 ? 'bg-danger' : 'bg-warning'
//                             }`}
//                           >
//                             {calculatePercentage(overdueAmount, item.totalAmount)}
//                           </span>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </Table>
//             </div>
//           ) : (
//             <div className='text-center py-5'>
//               <p>No data available. Set your filters and click "Load Report" to generate.</p>
//             </div>
//           )}
//         </CardBody>

//         {data.length > 0 && (
//           <CardFooter className='text-muted'>Report generated on {new Date().toLocaleString()}</CardFooter>
//         )}
//       </Card>

//       {/* Add some custom CSS for the aging buckets */}
//       <style>{`
//         .bg-age-0 { background-color: #e6f7e6; }
//         .bg-age-1 { background-color: #fff3e6; }
//         .bg-age-2 { background-color: #ffe6e6; }
//         .bg-age-3 { background-color: #ffcccc; }
//         .bg-age-0-light { background-color: #f5fff5; }
//         .bg-age-1-light { background-color: #fffaf5; }
//         .bg-age-2-light { background-color: #fff5f5; }
//         .bg-age-3-light { background-color: #fff0f0; }
//       `}</style>
//     </div>
//   );
// };

// export default AgingAnalysisReport;

import { ntxAPI } from '@API/axiosNeatex';
import { Card, CardBody, CardFooter } from '@components/card/card';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import type { APIResponse } from '@store/Shared/shared';
import { TreeSelect } from 'antd';
import React, { useState } from 'react';
import { Table, Spinner, Form, Row, Col, Button, Alert, CardHeader } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Define types for our data
interface AgingAnalysis {
  supplierId: string;
  supplierName: string;
  supplierName2: string;
  totalAmount: number;
  age0To30: number;
  age31To60: number;
  age61To90: number;
  ageOver90: number;
}

const AgingAnalysisReport: React.FC = () => {
  const { treeSuppliersData } = useGetSuppliersList();
  const [data, setData] = useState<AgingAnalysis[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // Filter states
  const [selectedSupplier, setSelectedSupplier] = useState<any>(''); // مثل التقارير السابقة
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [startDate] = dateRange; // هذا التقرير يستخدم AsOfDate فقط

  // Function to fetch data with filters
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await ntxAPI.get<APIResponse<AgingAnalysis[]>>('Reports/GetAgingAnalysisReport', {
        params: { SupplierId: selectedSupplier, AsOfDate: startDate }
      });

      if (data.succeeded === true) {
        setData(data.data);
      } else {
        setError(data instanceof Error ? data.message : 'حدث خطأ غير معروف');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'حدث خطأ غير معروف');
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setSelectedSupplier('all');
    setDateRange([null, null]);
  };

  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US').format(amount);
  };

  // Calculate percentage of total for each age bucket
  const calculatePercentage = (amount: number, total: number) => {
    if (total === 0) return '0%';
    return `${Math.round((amount / total) * 100)}%`;
  };

  return (
    <div className=' '>
      <Card className='border-0'>
        <CardBody>
          {error && (
            <Alert variant='danger' className='mb-4'>
              خطأ في تحميل البيانات: {error}
            </Alert>
          )}

          {/* Filters Section */}
          <Card className='mb-4'>
            <CardHeader className='d-flex justify-content-between align-items-center'>
              <div className='mb-0'>الفلاتر</div>
              {data.length > 0 && (
                <div>
                  <span className='me-2'>الإجمالي: {data.length} مورد</span>
                </div>
              )}
            </CardHeader>

            <CardBody>
              <Form>
                <Row className='g-3'>
                  <Col md={4}>
                    <Form.Group controlId='supplierFilter'>
                      <Form.Label>المورد</Form.Label>

                      <TreeSelect
                        showSearch
                        className='w-100'
                        treeLine
                        allowClear
                        treeDefaultExpandAll={false}
                        value={selectedSupplier}
                        onChange={(option: any) => {
                          setSelectedSupplier(option === null ? null : option);
                        }}
                        treeData={treeSuppliersData}
                        treeNodeFilterProp='title'
                        placeholder='اختر المورد'
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group controlId='dateRangeFilter'>
                      <Form.Label>تاريخ حتى</Form.Label>
                      <DatePicker
                        selected={startDate}
                        onChange={(d: Date | null) => setDateRange([d, null])}
                        isClearable={true}
                        className='form-control text-center'
                        placeholderText='اختر التاريخ'
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} className='text-end'>
                    <Button variant='secondary' onClick={resetFilters} className='me-2'>
                      تصفير الفلاتر
                    </Button>

                    <Button variant='primary' onClick={fetchData} disabled={loading}>
                      {loading ? (
                        <>
                          <Spinner
                            as='span'
                            animation='border'
                            size='sm'
                            role='status'
                            aria-hidden='true'
                            className='me-2'
                          />
                          جاري التحميل...
                        </>
                      ) : (
                        'تحميل التقرير'
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Results Section */}
          {loading ? (
            <div className='text-center my-5'>
              <Spinner animation='border' role='status'>
                <span className='visually-hidden'>جاري التحميل...</span>
              </Spinner>
              <p className='mt-2'>جاري تحميل بيانات الأعمار...</p>
            </div>
          ) : data.length > 0 ? (
            <div className='table-responsive'>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>المورد</th>
                    <th>إجمالي المبلغ</th>
                    <th className='bg-age-0'>0 - 30 يوم</th>
                    <th className='bg-age-1'>31 - 60 يوم</th>
                    <th className='bg-age-2'>61 - 90 يوم</th>
                    <th className='bg-age-3'>أكثر من 90 يوم</th>
                    <th>% متأخر</th>
                  </tr>
                </thead>

                <tbody>
                  {data.map((item, index) => {
                    const overdueAmount = item.age31To60 + item.age61To90 + item.ageOver90;
                    return (
                      <tr key={`${item.supplierId}-${index}`}>
                        <td>
                          <div>{item.supplierName}</div>
                          {item.supplierName2 && <div className='text-muted small'>{item.supplierName2}</div>}
                        </td>

                        <td>{formatCurrency(item.totalAmount)}</td>

                        <td className='bg-age-0-light'>
                          <div>{formatCurrency(item.age0To30)}</div>
                          <div className='text-muted small'>{calculatePercentage(item.age0To30, item.totalAmount)}</div>
                        </td>

                        <td className='bg-age-1-light'>
                          <div>{formatCurrency(item.age31To60)}</div>
                          <div className='text-muted small'>{calculatePercentage(item.age31To60, item.totalAmount)}</div>
                        </td>

                        <td className='bg-age-2-light'>
                          <div>{formatCurrency(item.age61To90)}</div>
                          <div className='text-muted small'>{calculatePercentage(item.age61To90, item.totalAmount)}</div>
                        </td>

                        <td className='bg-age-3-light'>
                          <div>{formatCurrency(item.ageOver90)}</div>
                          <div className='text-muted small'>{calculatePercentage(item.ageOver90, item.totalAmount)}</div>
                        </td>

                        <td>
                          <span
                            className={`badge ${
                              overdueAmount === 0 ? 'bg-success' : item.ageOver90 > 0 ? 'bg-danger' : 'bg-warning text-dark'
                            }`}
                          >
                            {calculatePercentage(overdueAmount, item.totalAmount)}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p>لا توجد بيانات. اختر الفلاتر ثم اضغط "تحميل التقرير" لعرض التقرير.</p>
            </div>
          )}
        </CardBody>

        {data.length > 0 && (
          <CardFooter className='text-muted'>تم إنشاء التقرير بتاريخ {new Date().toLocaleString('en-US')}</CardFooter>
        )}
      </Card>

      {/* Add some custom CSS for the aging buckets */}
      <style>{`
        .bg-age-0 { background-color: #e6f7e6; }
        .bg-age-1 { background-color: #fff3e6; }
        .bg-age-2 { background-color: #ffe6e6; }
        .bg-age-3 { background-color: #ffcccc; }
        .bg-age-0-light { background-color: #f5fff5; }
        .bg-age-1-light { background-color: #fffaf5; }
        .bg-age-2-light { background-color: #fff5f5; }
        .bg-age-3-light { background-color: #fff0f0; }
      `}</style>
    </div>
  );
};

export default AgingAnalysisReport;